module.exports = __webpack_public_path__ + "media/images/advisor/img_4_2-052d5b537e0a065f4c4ab22248712e49.png";